var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "108px",
    viewBox: "0 0 108 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 54,
    cy: 54,
    r: 54
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhoneX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s0901---My-profile",
    transform: "translate(-134.000000, -57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(134.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u2B1B-Background",
    fill: "#F4F6F6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,28.8 C59.976,28.8 64.8,33.624 64.8,39.6 C64.8,45.576 59.976,50.4 54,50.4 C48.024,50.4 43.2,45.576 43.2,39.6 C43.2,33.624 48.024,28.8 54,28.8 L54,28.8 Z M54,79.92 C45,79.92 37.044,75.312 32.4,68.328 C32.508,61.164 46.8,57.24 54,57.24 C61.164,57.24 75.492,61.164 75.6,68.328 C70.956,75.312 63,79.92 54,79.92 L54,79.92 Z",
    id: "\\uD83D\\uDD37-Icon-Color",
    fill: "#C4CACC",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.1a06af293ae899e29dc027521219564f.svg";
export { ForwardRef as ReactComponent };